<template>
    <CustomSelectOne v-if="!loading" :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="authority" item-value="id" :label="label" :required="required"
                     :noPlaceholder="noPlaceholder" :rules="rules"/>
</template>

<script>
import CustomSelectOne from "./inner/CustomSelectOne";
import {getBookTypes} from "@/swagger/vue-api-client";

export default {
    name: "CustomSelectOneBookType",
    components: {CustomSelectOne},

    props: {
        name: {
            type: String,
        },
        label: {
            type: String,
        },
        emptyValue: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        modelValue: null,
        noPlaceholder: {
            type: Boolean,
            default: false,
        },
        selectLocal: {
            type: Boolean,
            default: false,
        },
        rules: undefined,
    },

    emits: ["update:modelValue"],

    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    },

    data() {
        return {
            loading: false,
            items: [],
        };
    },

    beforeMount() {
        this.loading = true;
        getBookTypes().then((response) => {
            this.items = response.data;
            this.loading = false;
            if (this.selectLocal) {
                this.internalValue = this.items.find(item => item?.country?.local)?.id;
            }
        });
    },
};
</script>

<style scoped>

</style>
